import { render, staticRenderFns } from "./CommercialDocuments.vue?vue&type=template&id=31574567&"
import script from "./CommercialDocuments.vue?vue&type=script&lang=js&"
export * from "./CommercialDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports